"use client";

import React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material";

const Title = styled(DialogTitle)({
  fontSize: "20px",
});

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
}) {
  // MUI's default Dialog z-index (1300) sits below the /src/ui SideSheet
  // (--z-modal: 1310), so a confirm opened from inside a sheet — e.g. the
  // candidate Notes tab — would render behind it. Stays under --z-tooltip.
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ zIndex: "calc(var(--z-modal) + 1)" }}
    >
      <Title>{title}</Title>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelLabel}</Button>
        <Button onClick={onConfirm} autoFocus>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}